// apps/web/src/utils/checkApi.ts
export const checkApiHealth = async (baseUrl: string) => {
  try {
    const response = await fetch(`${baseUrl}/api/health`);
    const data = await response.json();
    return { ok: response.ok, data };
  } catch (error) {
    return { ok: false, error };
  }
};

export const testLogin = async (baseUrl: string, email: string, password: string) => {
  try {
    const response = await fetch(`${baseUrl}/api/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });
    const data = await response.json();
    return { ok: response.ok, data };
  } catch (error) {
    return { ok: false, error };
  }
};
